<script>
import AboutHeader from "@/components/headers/AboutHeader";
import Traits from "@/components/Traits";
import VennDiagram from "@/components/VennDiagram";
import Avatar from "@/components/Avatar";

import uxConferencePhoto from "@/assets/ux-conference.jpg";
import lunaPhoto from "@/assets/luna.jpg";
import affPhoto from "@/assets/aff.jpg";

export default {
  name: "About",
  components: {
    AboutHeader,
    Traits,
    VennDiagram,
    Avatar
  },
  data: () => {
    return {
      uxConferencePhoto,
      lunaPhoto,
      affPhoto
    };
  }
};
</script>

<template>
  <div>
    <div class="flex justify-center">
      <about-header />
    </div>
    <div class="intro-about-container">
      <h5>Currently, I am...</h5>
      <p>
        <strong>...looking for employment</strong> in
        <strong>UX design</strong> and or <strong>UX research.</strong>
      </p>
      <p>
        Most of the time, I love working on side projects, and taking steps to
        get better at design.
      </p>
      <p>
        On my off days, you can catch me doodling, reading in a cozy coffee
        shop, eating all my favorite foods, attending local art events, spending
        time with my friends, husband, and my puppy.
      </p>
      <p>Contact me <a href="">here</a></p>
    </div>
    <div class="photo-container flex justify-center">
      <img :src="uxConferencePhoto" />
      <img :src="lunaPhoto" />
      <img :src="affPhoto" />
    </div>
    <div class="photo-container-note">
      <strong>Photos left to right:</strong> Me at a UX conference in San
      Antonio, TX on usability; Luna my dog at 2 months old; TCK friend group
      and I, went to Austin Asian American Film Festival (AAFF) and got to meet
      Dante Basco and Andrea Walter after screening <em>Empty By Design.</em>
    </div>
    <section class="bg-purple">
      <div>
        <h5>How Peers See Me</h5>
        <p>
          I wanted to see <strong>how</strong> my <strong>peers</strong> would
          <strong>describe me</strong>, so I sent out a survey that let them
          remain anonymous.
        </p>
        <p>
          Here are some of their responses.
        </p>
        <traits />
      </div>
    </section>
    <section>
      <div>
        <h5>At a Glance</h5>
        <p>
          Between being mixed-race, multi-lingual, growing up in two countries,
          and having Okinawan, Japanese, and American (U.S.) cultures, I am
          definitely a <strong>Third Culture Kid (TCK)</strong> through and
          through.
        </p>
      </div>
    </section>
    <div class="glance-diagram">
      <venn-diagram />
      <avatar />
    </div>
  </div>
</template>

<style lang="scss">
.glance-diagram {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 248px;
  margin-top: 64px;
}

section {
  margin-top: 62px;

  div:first-of-type {
    width: 590px;
    margin: 0 auto;
    padding-top: 42px;
    padding-bottom: 48px;
  }
}

.bg-purple {
  background-color: var(--light-purple);
}

.photo-container-note {
  margin: 0 auto;
  width: 590px;
  font-family: Open Sans;
  font-size: 12px;
  line-height: 16px;

  color: rgba(51, 48, 54, 0.8);
}

.photo-container {
  margin-top: 35px;
  margin-bottom: 22px;

  img {
    height: 300px;
    border-radius: 5px;
    margin-left: 12px;
    margin-right: 12px;
  }
}

.intro-about-container {
  width: 589px;
  margin: 0 auto;

  p:first-of-type {
    margin-top: 22px;
  }
}

h5 {
  font-family: Lora;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 38px;

  color: #333036;
  margin-bottom: 26px;
}

p {
  font-family: Open Sans;
  font-size: 18px;
  line-height: 25px;

  margin-top: 12.5px;
  margin-bottom: 12.5px;
}
</style>
